module.exports = __webpack_public_path__ + "3b1b6b5d58b7e1b1fc04c3b9d27d9bea.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image0.png
 ** module id = 278
 ** module chunks = 0
 **/